import * as React from 'react'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { LoginServer } from 'merchant-components'
import { unifiedApi } from 'merchant-api'

const LoginRouteComponent = () => {
  const search = Route.useSearch()
  return <LoginServer redirect={search.redirect} />
}

export const Route = createFileRoute('/(public)/login/')({
  component: LoginRouteComponent,
  validateSearch: (search) => {return {redirect: search.redirect as string | undefined}},
  loaderDeps: ({ search }) => ({ redirect: search.redirect }),
  loader: async ({ context, deps }) => {
    let authed = false
    try {
      // 401s reject as AppError.Unauthenticated — an anonymous visitor just stays on the login page.
      await context.queryClient.ensureQueryData({
        ...unifiedApi.queryOptions('get', '/client/user/v1/profile'),
        retry: false,
        staleTime: 1000 * 60 * 5,
      })
      authed = true
    } catch { /* not signed in */ }
    if (authed) throw redirect({ to: deps.redirect || '/' })
  }
})
